import { colors, fontSizes } from '../../Components/consts'
import { styled } from '@mui/system'

type WeekProps = {
  selected?: boolean
  direction?: 'vertical' | 'horizontal'
}

export const WeekSliderCon = styled('div')<WeekProps>(
  ({ direction, selected, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: direction === 'vertical' ? 'flex-start' : 'center',
    height: direction === 'vertical' ? 'auto' : 80,
    background: direction === 'vertical' && selected ? `${colors.yellow}70` : 'none',
    padding: direction === 'vertical' ? theme.spacing(1, 0, 0, 1) : 0,
    borderBottom: selected ? `solid 4px ${colors.yellow}` : 'none',
    borderRadius: direction === 'vertical' ? '10px 0 0 10px' : 'none',
    marginBottom: theme.spacing(0),
    marginLeft:  direction === 'vertical' ? 5 : 0,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: 140,
      height: direction === 'vertical' ? 46 : 60,
    },
    '& .inner': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: direction === 'vertical' ? theme.spacing(0.5, 0) : 0,
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
      },
      '& img': {
        width: 30,
        marginRight: 3,
        [theme.breakpoints.between('md', 'lg')]: {
          width: 20,
        },
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
      '& .textCon': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: direction === 'vertical' ? 'flex-start' : 'center',
        '& .subText': {
          fontSize: direction === 'vertical' ? fontSizes.small : fontSizes.medium,
          color: selected ? colors.text : colors.gray.gray70,
          fontWeight: 'normal',
          marginBottom: 2,
          marginTop: 0,
          [theme.breakpoints.between('sm', 'lg')]: {
            fontSize: direction === 'vertical' ? fontSizes.small : fontSizes.small,
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: fontSizes.xSmall,
            textAlign: 'center',
          },
        },
        '& .mainText': {
          fontSize: direction === 'vertical' ? fontSizes.medium : fontSizes.semiLarge,
          color: selected ? colors.black : colors.gray.gray90,
          fontWeight: 'bold',
          marginBottom: 0,
          [theme.breakpoints.between('sm', 'lg')]: {
            fontSize: direction === 'vertical' ? fontSizes.small : fontSizes.medium,
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: fontSizes.small,
          },
        },
      },
    },
  })
)

export const SliderSeasonLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderBottom: `solid 1px ${colors.gray.gray20}`,
  padding: theme.spacing(0, 1),
  margin: theme.spacing(2, 0, 0, 0),
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
  '& h2': {
    fontSize: fontSizes.small,
    fontWeight: 'bold',
    color: colors.gray.gray70,
    marginBottom: 3,
  },
}))
